import * as React from 'react';
import { navigate } from 'router';

import CurrentOrgInjector from '~/apps/shared/containers/app/CurrentOrgInjector';
import UserEditPopup from '~/apps/shared/containers/users/UserEditPopup';


export default function({ userId }) {
  return (
    <CurrentOrgInjector
      component={UserEditPopup}
      userId={userId}
      onReturn={() => navigate('receiver.admin.settings.team')}
    />
  );
};
